import dateFormat from "dateformat";

const DEFAULT_FORMAT = process.env.REACT_APP_DATE_FORMAT || "ddd, dS mmm, yyyy";

export const formatDate = (date, format = DEFAULT_FORMAT) => {
  if (!date) return "";
  try {
    return dateFormat(date, format);
  } catch (e) {
    return "";
  }
};

export const canEditHireChargeTillCollectionDate = (collectionDate) => {
  if (!collectionDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const collection = new Date(collectionDate);
  collection.setHours(0, 0, 0, 0);

  return today > collection;
};